import React, { useState } from 'react'
import {
  Card,
  Cards,
  Column,
  Container,
  Grid,
} from 'src/components/framework/ui'
import { AnalystChart } from 'src/components/page/analyst-chart/analyst-chart'
import { AnalystConsensus } from 'src/components/page/analyst-consensus/analyst-consensus'
import { AnalystForecast } from 'src/components/page/analyst-forecast/analyst-forecast'
import { Cybertorial } from 'src/components/page/cybertorial/cybertorial'
import { EventsList } from 'src/components/page/events-list/events-list'
import { FAQ } from 'src/components/page/faq/faq'
import { FinancialSummaryTable } from 'src/components/page/financial-summary/financial-summary-table'
import { GraphicalHistory } from 'src/components/page/graphical-history/graphical-history'
import SignupCTA from 'src/components/page/layout/footer/signup/signup-banner'
import { SecurityInfoContainer } from 'src/components/page/layout/security-info'
import { NewsList } from 'src/components/page/news-list/news-list'
import { LazyPriceChart } from 'src/components/page/price-chart/lazy-price-chart'
import { PricePerformance } from 'src/components/page/price-performance/price-performance'
import { Profile } from 'src/components/page/profile/profile'
import { GrowthValueRatios } from 'src/components/page/ratios/growth-value/growth-value'
import { GuruScreens } from 'src/components/page/ratios/guru-screens/guru-screens'
import { MomentumRatios } from 'src/components/page/ratios/momentum/momentum'
import { OtherRatios } from 'src/components/page/ratios/other/other'
import { QualityRatio } from 'src/components/page/ratios/quality/quality'
import { RecentHistory } from 'src/components/page/ratios/recent-history/recent-history'
import { FScore } from 'src/components/page/ratios/scores/f-score/f-score'
import { MScore } from 'src/components/page/ratios/scores/m-score/m-score'
import { ZScore } from 'src/components/page/ratios/scores/z-score/z-score'
import { ShareholderActivity } from 'src/components/page/ratios/shareholder-activity/shareholder-activity'
import { SimilarSecurities } from 'src/components/page/similar-securities/similar-securities'
import { useStockReportContext } from 'src/contexts/stock-report.context'

export const ReportMain: React.FC = () => {
  const { report } = useStockReportContext()

  const hasNews = report.news.length > 0
  const hasEvents =
    report.events.past.length > 0 || report.events.upcoming.length > 0
  const hasNewsOrEvents = hasNews || hasEvents
  const hasSimilar = report.similar.length > 0
  const [hidePosition, setHidePosition] = useState(0)

  return (
    <>
      <main>
        <Container>
          <SecurityInfoContainer />
          <Cards variants={['floating']}>
            <Card>
              <Grid>
                <Column msm={12} ts={12} ss={5}>
                  <LazyPriceChart />
                </Column>
                <Column msm={12} ts={12} ss={3}>
                  <MomentumRatios />
                </Column>
                <Column msm={12} ts={12} ss={4}>
                  <GrowthValueRatios />
                </Column>
              </Grid>
              <Grid>
                <Column msm={12} ts={12} ss={4}>
                  <ShareholderActivity />
                </Column>
                <Column msm={12} ts={12} ss={4}>
                  <GuruScreens />
                </Column>
                <Column msm={12} ts={12} ss={4}>
                  <QualityRatio />
                </Column>
              </Grid>
              <Grid>
                <Column msm={12} ts={12} ss={8}>
                  <FinancialSummaryTable />
                </Column>
                <Column msm={12} ts={12} ss={4}>
                  <Cards variants={['outlined']}>
                    <Card>
                      <FScore />
                    </Card>
                    <Card>
                      <ZScore />
                    </Card>
                    <Card>
                      <MScore />
                    </Card>
                  </Cards>
                  <div className={'stk-space-out-t-3'}>
                    <OtherRatios />
                  </div>
                  <div className={'stk-space-out-t-3'}>
                    <RecentHistory />
                  </div>
                </Column>
              </Grid>
            </Card>

            {report.cybertorial.articles.length > 0 && (
              <Card>
                <Cybertorial />
              </Card>
            )}
            <Card>
              <GraphicalHistory />
            </Card>
            <Card>
              <Grid>
                <Column msm={12} ts={12} ss={8}>
                  <AnalystForecast />
                </Column>
                <Column msm={12} ts={12} ss={4}>
                  <Cards variants={['outlined']}>
                    <Card>
                      <AnalystConsensus />
                    </Card>
                    <Card>
                      <AnalystChart />
                    </Card>
                  </Cards>
                </Column>
              </Grid>
            </Card>
            <Card>
              <Profile />
            </Card>
            <Card>
              <PricePerformance />
            </Card>
            {(hasNewsOrEvents || hasSimilar) && (
              <Card>
                <Grid>
                  {hasNewsOrEvents && (
                    <Column msm={12} ts={12} ss={8}>
                      {hasNews && <NewsList />}
                      <div className={'stk-space-out-t-5'}>
                        {hasEvents && <EventsList />}
                      </div>
                    </Column>
                  )}
                  <Column msm={12} ts={12} ss={hasNewsOrEvents ? 4 : 12}>
                    {hasSimilar && <SimilarSecurities />}
                  </Column>
                </Grid>
              </Card>
            )}
            <Card>
              <Grid>
                <Column msm={12} ts={12} ss={8}>
                  <FAQ />
                </Column>
              </Grid>
            </Card>
          </Cards>
        </Container>
      </main>
      <SignupCTA trackPosition={setHidePosition} />
      <SignupCTA sticky hidePosition={hidePosition} />
    </>
  )
}
